import React, { useEffect, useRef } from 'react';

const PASTABLE_IMAGE_TYPES: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

/**
 * 채팅 입력창에서 이미지 복사/붙여넣기 업로드를 지원한다.
 */
export const usePasteImageUpload = (
  textAreaRef: React.RefObject<HTMLTextAreaElement>,
  fileUpload: (files: File[]) => void,
) => {
  const pasteCount = useRef(0);
  const fileUploadRef = useRef(fileUpload);
  fileUploadRef.current = fileUpload;

  useEffect(() => {
    const textArea = textAreaRef.current;
    if (!textArea) return;

    const handlePaste = (event: ClipboardEvent) => {
      const clipboardData = event.clipboardData;
      if (!clipboardData) return;

      const fromFiles = Array.from(clipboardData.files);
      const fromItems = Array.from(clipboardData.items)
        .filter((item) => item.kind === 'file')
        .map((item) => item.getAsFile())
        .filter((file): file is File => file !== null);

      const candidates = fromFiles.length > 0 ? fromFiles : fromItems;
      const images = candidates.filter((file) => file.type in PASTABLE_IMAGE_TYPES);

      if (images.length === 0) return;

      event.preventDefault();

      const renamed = images.map((image) => {
        pasteCount.current += 1;
        const extension = PASTABLE_IMAGE_TYPES[image.type];
        return new File([image], `pasted-image-${pasteCount.current}.${extension}`, { type: image.type });
      });

      fileUploadRef.current(renamed);
    };

    textArea.addEventListener('paste', handlePaste);
    return () => {
      textArea.removeEventListener('paste', handlePaste);
    };
  }, [textAreaRef]);
};
